import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import CssBaseline from '@material-ui/core/CssBaseline';
import store, { history } from 'redux/store';
import App from 'containers/App/App';
import ErrorBoundary from 'containers/ErrorBoundary/ErrorBoundary';
import { unregister } from 'registerServiceWorker';
import muiTheme from 'theme/muiTheme';
import { HOTJAR_SITE_ID } from './config';
import { saveRefersionFieldsToStorage } from 'utils/refersion';
import { parseQuery } from 'utils/url';
import './index.scss';
// eslint-disable-next-line no-unused-vars
import beforeunload from './utils/beforeunload';

const target = document.querySelector('#root');

window.addEventListener('error', (event) => {
	ErrorBoundary.handleUncaughtError(event, target);
});
window.addEventListener('unhandledrejection', (event) => {
	ErrorBoundary.handleUnhandledPromiseRejection(event, target);
});

/**
 * Adds Hotjar tracking code to document's head. Docs:
 * https://help.hotjar.com/hc/en-us/articles/115009499088-The-Hotjar-Tracking-Code
 */
const addHotjarScript = () => {
	// Don't track session on dev environment or if there's no key
	if (process.env.NODE_ENV === 'development' || !HOTJAR_SITE_ID) { return; }

	var script = document.createElement('script');
	var head = document.getElementsByTagName('head')[0];

	script.innerHTML =
		'(function(h,o,t,j,a,r){' +
		'h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};' +
		'h._hjSettings={hjid:' +
		HOTJAR_SITE_ID +
		',hjsv:6};' +
		'a=o.getElementsByTagName(\'head\')[0];' +
		'r=o.createElement(\'script\');r.async=1;' +
		'r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;' +
		'a.appendChild(r);' +
		'})(window,document,\'https://static.hotjar.com/c/hotjar-\',\'.js?sv=\');';

	head.appendChild(script);
};

const originalSearch = window.location.search;
const originalHash = window.location.hash;

// Remove query string from URL
const queryParams = parseQuery(window.location.search);
window.history.replaceState({}, document.title, `/${window.location.hash}`);

const lang = queryParams['lang'];
lang && window.localStorage.setItem('lang', lang);

const isDiscountTakeoverFromWebsite = window.location.href.indexOf('pserial') !== -1 &&
	window.location.href.indexOf('pemail') !== -1;

const isUpgradePopup = window.location.href.indexOf('upgrade-popup') !== -1;
const isReUpgradePopup = window.location.href.indexOf('is-re-popup') !== -1;

const isCouponIdProvided = window.location.href.indexOf('cid') !== -1;

const isDesktopApp = (window.location.href.indexOf('desktop-app') !== -1 ||
window.location.href.indexOf('prod=') !== -1 ||
queryParams['prod'] ||
queryParams['desktop-app'] || isDiscountTakeoverFromWebsite) && 
window.location.href.indexOf('source=pricing') === -1 &&
window.location.href.indexOf('BROKERAGE') === -1 &&
window.location.href.indexOf('INDIVIDUAL_AGENT') === -1
;

const isCbPlanProvided = window.location.href.indexOf('chargebee-plan-id') !== -1;

render(
		<Provider store={store}>
			<ConnectedRouter history={history}>
				<MuiThemeProvider theme={muiTheme}>
					<CssBaseline />
					<App
						reloadApp={Boolean(queryParams['reload-app'])}
						isDesktopApp={isDesktopApp}
						isCbPlanProvided={isCbPlanProvided}
						isDiscountTakeoverFromWebsite={isDiscountTakeoverFromWebsite}
						isUpgradePopup={isUpgradePopup}
						isReUpgradePopup={isReUpgradePopup}
						isCouponIdProvided={isCouponIdProvided}
						originalSearch={originalSearch}
						originalHash={originalHash}
					/>
				</MuiThemeProvider>
			</ConnectedRouter>
		</Provider>
	,
	target
);

unregister();
addHotjarScript();
saveRefersionFieldsToStorage();


// WEBPACK FOOTER //
// ./src/index.js